var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedgate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.11 6.09L10.55 0L0 6.09V18.28L10.55 24.37L21.11 18.28V6.09Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85019 7.83008C3.76019 7.83008 4.50018 8.57008 4.50018 9.48008V21.8701C4.50018 22.0101 4.38017 22.1301 4.24017 22.1301H1.46017C1.32017 22.1301 1.2002 22.0101 1.2002 21.8701V9.48008C1.2002 8.57008 1.94019 7.83008 2.85019 7.83008Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 15.68L4.5 17.74V9.48998L8.69 7.62998C9.05 7.46998 9.45001 7.72998 9.45001 8.11998V15.19C9.45001 15.4 9.32 15.6 9.13 15.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6394 22.1401H16.8594C16.7194 22.1401 16.5994 22.0201 16.5994 21.8801V9.49014C16.5994 8.58014 17.3394 7.84013 18.2494 7.84013C19.1594 7.84013 19.8994 8.58014 19.8994 9.49014V21.8801C19.8994 22.0201 19.7794 22.1401 19.6394 22.1401Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9694 15.68L16.5994 17.74V9.48998L12.4094 7.62998C12.0494 7.46998 11.6494 7.72998 11.6494 8.11998V15.19C11.6494 15.4 11.7794 15.6 11.9694 15.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedgate);
export default __webpack_public_path__ + "static/media/speedgate.a069e6f3.svg";
export { ForwardRef as ReactComponent };